import { render, staticRenderFns } from "./EvolucaoTicketCliente.vue?vue&type=template&id=233c177a&scoped=true&"
import script from "./EvolucaoTicketCliente.vue?vue&type=script&lang=js&"
export * from "./EvolucaoTicketCliente.vue?vue&type=script&lang=js&"
import style0 from "./EvolucaoTicketCliente.vue?vue&type=style&index=0&id=233c177a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "233c177a",
  null
  
)

export default component.exports